import { render, staticRenderFns } from "./Moderacao.vue?vue&type=template&id=df438fa2"
import script from "./Moderacao.vue?vue&type=script&lang=js"
export * from "./Moderacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports